import { Grid } from '@material-ui/core'
import { Filter, TextField, useFilter } from 'elentari'
import React from 'react'
import { Field } from 'react-final-form'

const MensagemFilter = () => {
  const filter = useFilter({})
  return (
    <Filter {...filter} labels={{ find: 'buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item sm={12}>
          <Field
            fullWidth
            name="mensagem"
            label="Mensagem"
            component={TextField}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

export default MensagemFilter
